/*
 * @Author: 刑天
 * @Date: 2022-01-05 17:23:10
 * @LastEditTime: 2022-01-12 15:20:32
 * @Description: 战神
 */

export const coupon_zhCN = {
  'coupon.mgt.volume.n01.lbl01': `基本设置`,
  'coupon.mgt.volume.n01.lbl02': `优惠券名称`,
  'coupon.mgt.volume.n01.placeholder03': `请输入优惠券名称`,
  'coupon.mgt.volume.n01.lbl04': `优惠券副标题`,
  'coupon.mgt.volume.n01.placeholder05': `请输入优惠券副标题`,
  'coupon.mgt.volume.n01.lbl06': `优惠券备注`,
  'coupon.mgt.volume.n01.placeholder07': `请输入优惠券备注`,
  'coupon.mgt.volume.n01.lbl08': `发放总量`,
  'coupon.mgt.volume.n01.placeholder09': `请输入发放总量`,
  'coupon.mgt.volume.n01.rdo10': `使用门槛`,
  'coupon.mgt.volume.n01.lbl11': `无使用门槛`,
  'coupon.mgt.volume.n01.lbl12': `订单满`,
  'coupon.mgt.volume.n01.lbl13': `元可使用`,
  'coupon.mgt.volume.n01.lbl14': `优惠内容`,
  'coupon.mgt.volume.n01.lbl15': `减免`,
  'coupon.mgt.volume.n01.lbl16': `元`,
  'coupon.mgt.volume.n01.txt17': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'coupon.mgt.volume.n01.lbl18': `用券时间`,
  'coupon.mgt.volume.n01.rdo19': `开始日期`,
  'coupon.mgt.volume.n01.rdo20': `结束日期`,
  'coupon.mgt.volume.n01.chb21': `领券`,
  'coupon.mgt.volume.n01.lbl22': `天内可用`,
  'coupon.mgt.volume.n01.lbl23': `领取和使用规则`,
  'coupon.mgt.volume.n01.rdo24': `领取人限制`,
  'coupon.mgt.volume.n01.lbl25': `不限制，所有人可领`,
  'coupon.mgt.volume.n01.lbl26': `指定用户身份可领（仅会员）`,
  'coupon.mgt.volume.n01.rdo27': `每人限领次数`,
  'coupon.mgt.volume.n01.lbl28': `不限次数`,
  'coupon.mgt.volume.n01.lbl29': `限`,
  'coupon.mgt.volume.n01.lbl30': `次`,
  'coupon.mgt.volume.n01.chb31': `分享设置`,
  'coupon.mgt.volume.n01.lbl32': `优惠券允许分享给好友领取`,
  'coupon.mgt.volume.n01.chb33': `转赠设置`,
  'coupon.mgt.volume.n01.lbl34': `优惠券允许转增给好友`,
  'coupon.mgt.volume.n01.chb35': `使用条件`,
  'coupon.mgt.volume.n01.lbl36': `不可与其他优惠券叠加使用`,
  'coupon.mgt.volume.n01.lbl37': `不可会员优惠同享`,
  'coupon.mgt.volume.n01.lbl38': `不可店铺促销同享`,
  'coupon.mgt.volume.n01.lbl39': `不可非正价商品同享`,
  'coupon.mgt.volume.n01.lbl40': `员工券`,
  'coupon.mgt.volume.n01.lbl41': `使用此券消费金额可累计消费积分`,
  'coupon.mgt.volume.n01.lbl42': `使用此券消费金额可算升级`,
  'coupon.mgt.volume.n01.lbl43': `限制订单内商品件数`,
  'coupon.mgt.volume.n01.lbl44': `件`,
  'coupon.mgt.volume.n01.lbl45': `使用说明`,
  'coupon.mgt.volume.n02.lbl01': `渠道设置`,
  'coupon.mgt.volume.n02.chb02': `适用渠道`,
  'coupon.mgt.volume.n02.lbl03': `官网`,
  'coupon.mgt.volume.n02.lbl04': `爱步官网小程序`,
  'coupon.mgt.volume.n02.lbl05': `线下渠道`,
  'coupon.mgt.volume.n02.rdo06': `适用公司`,
  'coupon.mgt.volume.n02.lbl07': `全部公司`,
  'coupon.mgt.volume.n02.rdo08': `指定公司`,
  'coupon.mgt.volume.n02.rdo09': `适用门店`,
  'coupon.mgt.volume.n02.lbl10': `全部门店`,
  'coupon.mgt.volume.n02.lbl11': `指定门店`,
  'coupon.mgt.volume.n03.lbl01': `商品设置`,
  'coupon.mgt.volume.n03.rdo02': `适用商品`,
  'coupon.mgt.volume.n03.lbl03': `全部商品`,
  'coupon.mgt.volume.n03.lbl04': `适用商品`,
  'coupon.mgt.volume.n04.lbl01': `同步设置`,
  'coupon.mgt.volume.n04.lbl02': `微信卡券同步设置`,
  'coupon.mgt.volume.n04.lbl03': `微信卡券`,
  'coupon.mgt.volume.n04.chb04': `领取后可同步至微信卡包`,
  'coupon.mgt.volume.n04.rdo05': `选择模板`,
  'coupon.mgt.volume.n04.lbl06': `适用商品范围`,
  'coupon.mgt.volume.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'coupon.mgt.volume.n05.lbl01': `优惠券减免是必填项`,
  'coupon.mgt.pricevalue.n01.lbl01': `基本设置`,
  'coupon.mgt.pricevalue.n01.lbl02': `优惠券名称`,
  'coupon.mgt.pricevalue.n01.placeholder03': `请输入优惠券名称`,
  'coupon.mgt.pricevalue.n01.lbl04': `优惠券副标题`,
  'coupon.mgt.pricevalue.n01.placeholder05': `请输入优惠券副标题`,
  'coupon.mgt.pricevalue.n01.lbl06': `优惠券备注`,
  'coupon.mgt.pricevalue.n01.placeholder07': `请输入优惠券备注`,
  'coupon.mgt.pricevalue.n01.lbl08': `发放总量`,
  'coupon.mgt.pricevalue.n01.placeholder09': `请输入发放总量`,
  'coupon.mgt.pricevalue.n01.rdo10': `使用门槛`,
  'coupon.mgt.pricevalue.n01.lbl11': `无使用门槛`,
  'coupon.mgt.pricevalue.n01.lbl12': `折扣比例`,
  'coupon.mgt.pricevalue.n01.lbl13': `（原价为1,0.88即为八八折）`,
  'coupon.mgt.pricevalue.n01.txt14': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'coupon.mgt.pricevalue.n01.lbl15': `用券时间`,
  'coupon.mgt.pricevalue.n01.rdo16': `开始日期`,
  'coupon.mgt.pricevalue.n01.rdo17': `结束日期`,
  'coupon.mgt.pricevalue.n01.chb18': `领券`,
  'coupon.mgt.pricevalue.n01.lbl19': `领取和使用规则`,
  'coupon.mgt.pricevalue.n01.rdo20': `领取人限制`,
  'coupon.mgt.pricevalue.n01.lbl21': `不限制，所有人可领`,
  'coupon.mgt.pricevalue.n01.lbl22': `指定用户身份可领（仅会员）`,
  'coupon.mgt.pricevalue.n01.rdo23': `每人限领次数`,
  'coupon.mgt.pricevalue.n01.lbl24': `不限次数`,
  'coupon.mgt.pricevalue.n01.lbl25': `限`,
  'coupon.mgt.pricevalue.n01.lbl26': `次`,
  'coupon.mgt.pricevalue.n01.chb27': `分享设置`,
  'coupon.mgt.pricevalue.n01.lbl28': `优惠券允许分享给好友领取`,
  'coupon.mgt.pricevalue.n01.chb29': `转赠设置`,
  'coupon.mgt.pricevalue.n01.lbl30': `优惠券允许转增给好友`,
  'coupon.mgt.pricevalue.n01.chb31': `使用条件`,
  'coupon.mgt.pricevalue.n01.lbl32': `不可与其他优惠券叠加使用`,
  'coupon.mgt.pricevalue.n01.lbl33': `不可会员优惠同享`,
  'coupon.mgt.pricevalue.n01.lbl34': `不可店铺促销同享`,
  'coupon.mgt.pricevalue.n01.lbl35': `不可非正价商品同享`,
  'coupon.mgt.pricevalue.n01.lbl36': `员工券`,
  'coupon.mgt.pricevalue.n01.lbl37': `使用此券消费金额可累计消费积分`,
  'coupon.mgt.pricevalue.n01.lbl38': `使用此券消费金额可算升级`,
  'coupon.mgt.pricevalue.n01.lbl39': `限制订单内商品件数`,
  'coupon.mgt.pricevalue.n01.lbl40': `件`,
  'coupon.mgt.pricevalue.n01.lbl41': `使用说明`,
  'coupon.mgt.pricevalue.n01.txt42': `优惠券名称是必填项`,
  'coupon.mgt.pricevalue.n01.txt43': `优惠券副标题是必填项`,
  'coupon.mgt.pricevalue.n01.txt44': `发放总量是必填项`,
  'coupon.mgt.pricevalue.n01.txt45': `金额是必填项`,
  'coupon.mgt.pricevalue.n01.txt46': `内可用`,
  'coupon.mgt.pricevalue.n01.txt47': `优惠减免是必填项`,
  'coupon.mgt.pricevalue.n01.txt48': `满足件数是必填项`,
  'coupon.mgt.pricevalue.n01.txt49': `请输入折扣比例`,
  'coupon.mgt.pricevalue.n01.txt50': `折扣比例是必填项`,
  'coupon.mgt.pricevalue.n01.txt51': `折扣比例不得大于1`,
  'coupon.mgt.pricevalue.n01.txt52': `填写商品描述`,
  'coupon.mgt.pricevalue.n01.txt53': `商品描述必填项`,
  'coupon.mgt.pricevalue.n01.txt54': `用券时间是必选项`,
  'coupon.mgt.pricevalue.n01.txt55': `当日`,
  'coupon.mgt.pricevalue.n01.txt56': `次日`,
  'coupon.mgt.pricevalue.n01.txt57': `起`,
  'coupon.mgt.pricevalue.n01.txt58': `天数是必填项`,
  'coupon.mgt.pricevalue.n01.txt59': `每人限领次数是必填项`,
  'coupon.mgt.pricevalue.n01.txt60': `如果不限制商品件数，输入0`,
  'coupon.mgt.pricevalue.n01.txt61': `填写优惠券的具体使用信息`,
  'coupon.mgt.pricevalue.n01.txt62': `使用说明是必填项`,
  'coupon.mgt.pricevalue.n01.txt63': `门店Code`,
  'coupon.mgt.pricevalue.n01.txt64': `门店名称`,
  'coupon.mgt.pricevalue.n01.txt65': `操作`,
  'coupon.mgt.pricevalue.n01.txt66': `选择门店`,
  'coupon.mgt.pricevalue.n01.txt67': `选择不可用门店`,
  'coupon.mgt.pricevalue.n01.txt68': `请输入门店名称`,
  'coupon.mgt.pricevalue.n01.txt69': `适用渠道至少选择一项`,
  'coupon.mgt.pricevalue.n01.txt70': `公司名称`,
  'coupon.mgt.pricevalue.n01.txt71': `请选择公司`,
  'coupon.mgt.pricevalue.n01.txt72': `请添加适用门店`,
  'coupon.mgt.pricevalue.n01.txt73': `可用门店`,
  'coupon.mgt.pricevalue.n01.txt74': `不可用门店`,
  'coupon.mgt.pricevalue.n01.txt75': `添加`,
  'coupon.mgt.pricevalue.n01.txt76': `共`,
  'coupon.mgt.pricevalue.n01.txt77': `编码`,
  'coupon.mgt.pricevalue.n01.txt78': `名称`,
  'coupon.mgt.pricevalue.n01.txt79': `内容`,
  'coupon.mgt.pricevalue.n01.txt80': `类型`,
  'coupon.mgt.pricevalue.n01.txt81': `款号`,
  'coupon.mgt.pricevalue.n01.txt82': `货号`,
  'coupon.mgt.pricevalue.n01.txt83': `系列`,
  'coupon.mgt.pricevalue.n01.txt84': `全球季节`,
  'coupon.mgt.pricevalue.n01.txt85': `品类`,
  'coupon.mgt.pricevalue.n01.txt86': `大类`,
  'coupon.mgt.pricevalue.n01.txt87': `请输入款号名称`,
  'coupon.mgt.pricevalue.n01.txt88': `请输入货号名称`,
  'coupon.mgt.pricevalue.n01.txt89': `请输入商品名称`,
  'coupon.mgt.pricevalue.n01.txt90': `请输入系列名称`,
  'coupon.mgt.pricevalue.n01.txt91': `请输入全球季节名称`,
  'coupon.mgt.pricevalue.n01.txt92': `请输入品类名称`,
  'coupon.mgt.pricevalue.n01.txt93': `请输入大类名称`,
  'coupon.mgt.pricevalue.n01.txt94': `请输入款号名称`,
  'coupon.mgt.pricevalue.n01.txt95': `请输入系列名称`,
  'coupon.mgt.pricevalue.n01.txt96': `请输入配件种类名称`,
  'coupon.mgt.pricevalue.n01.txt97': `请添加适用商品`,
  'coupon.mgt.pricevalue.n01.txt98': `可用商品`,
  'coupon.mgt.pricevalue.n01.txt99': `第`,
  'coupon.mgt.pricevalue.n01.txt100': `不可用商品`,
  'coupon.mgt.pricevalue.n01.txt101': `请选择模板`,
  'coupon.mgt.pricevalue.n02.lbl01': `请输入折扣比例`,
  'coupon.mgt.pricevalue.n02.lbl02': `折扣比例是必填项`,
  'coupon.mgt.pricevalue.n02.lbl03': `折扣比例不得大于1`,
  'coupon.mgt.exchange.n01.lbl08': `发放总量`,
  'coupon.mgt.exchange.n01.placeholder09': `请输入发放总量`,
  'coupon.mgt.exchange.n01.rdo10': `使用门槛`,
  'coupon.mgt.exchange.n01.lbl11': `无使用门槛`,
  'coupon.mgt.exchange.n01.lbl12': `商品描述`,
  'coupon.mgt.exchange.n01.txt13': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'coupon.mgt.exchange.n01.lbl14': `用券时间`,
  'coupon.mgt.exchange.n01.rdo15': `开始日期`,
  'coupon.mgt.exchange.n01.rdo16': `结束日期`,
  'coupon.mgt.exchange.n01.chb17': `领券`,
  'coupon.mgt.exchange.n01.lbl18': `天内可用`,
  'coupon.mgt.exchange.n01.lbl19': `领取和使用规则`,
  'coupon.mgt.exchange.n01.rdo20': `领取人限制`,
  'coupon.mgt.exchange.n01.lbl21': `不限制，所有人可领`,
  'coupon.mgt.exchange.n01.lbl22': `指定用户身份可领（仅会员）`,
  'coupon.mgt.exchange.n01.rdo23': `每人限领次数`,
  'coupon.mgt.exchange.n01.lbl24': `不限次数`,
  'coupon.mgt.exchange.n01.lbl25': `限`,
  'coupon.mgt.exchange.n01.lbl26': `次`,
  'coupon.mgt.exchange.n01.chb27': `分享设置`,
  'coupon.mgt.exchange.n01.lbl28': `优惠券允许分享给好友领取`,
  'coupon.mgt.exchange.n01.chb29': `转赠设置`,
  'coupon.mgt.exchange.n01.lbl30': `优惠券允许转增给好友`,
  'coupon.mgt.exchange.n01.chb31': `使用条件`,
  'coupon.mgt.exchange.n01.lbl32': `不可与其他优惠券叠加使用`,
  'coupon.mgt.exchange.n01.lbl33': `不可会员优惠同享`,
  'coupon.mgt.exchange.n01.lbl34': `不可店铺促销同享`,
  'coupon.mgt.exchange.n01.lbl35': `不可非正价商品同享`,
  'coupon.mgt.exchange.n01.lbl36': `员工券`,
  'coupon.mgt.exchange.n01.lbl37': `使用此券消费金额可累计消费积分`,
  'coupon.mgt.exchange.n01.lbl38': `使用此券消费金额可算升级`,
  'coupon.mgt.exchange.n01.lbl39': `限制订单内商品件数`,
  'coupon.mgt.exchange.n01.lbl40': `件`,
  'coupon.mgt.exchange.n01.lbl41': `使用说明`,
  'coupon.mgt.exchange.n02.lbl01': `渠道设置`,
  'coupon.mgt.exchange.n02.chb02': `适用渠道`,
  'coupon.mgt.exchange.n02.lbl03': `官网`,
  'coupon.mgt.exchange.n02.lbl04': `爱步官网小程序`,
  'coupon.mgt.exchange.n02.lbl05': `线下渠道`,
  'coupon.mgt.exchange.n02.rdo06': `适用公司`,
  'coupon.mgt.exchange.n02.lbl07': `全部公司`,
  'coupon.mgt.exchange.n02.rdo08': `指定公司`,
  'coupon.mgt.exchange.n02.rdo09': `适用门店`,
  'coupon.mgt.exchange.n02.lbl10': `全部门店`,
  'coupon.mgt.exchange.n02.lbl11': `指定门店`,
  'coupon.mgt.exchange.n03.lbl01': `商品设置`,
  'coupon.mgt.exchange.n03.rdo02': `适用商品`,
  'coupon.mgt.exchange.n03.lbl03': `全部商品`,
  'coupon.mgt.exchange.n03.lbl04': `适用商品`,
  'coupon.mgt.exchange.n04.lbl01': `同步设置`,
  'coupon.mgt.exchange.n04.lbl02': `微信卡券同步设置`,
  'coupon.mgt.exchange.n04.lbl03': `微信卡券`,
  'coupon.mgt.exchange.n04.chb04': `领取后可同步至微信卡包`,
  'coupon.mgt.exchange.n04.rdo05': `选择模板`,
  'coupon.mgt.exchange.n04.lbl06': `适用商品范围`,
  'coupon.mgt.exchange.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'coupon.mgt.exchange.n05.lbl01': `请填写商品描述`,
  'coupon.mgt.exchange.n05.lbl02': `商品描述是必填项`,
  'coupon.mgt.pricequantity.n01.lbl01': `基本设置`,
  'coupon.mgt.pricequantity.n01.lbl02': `优惠券名称`,
  'coupon.mgt.pricequantity.n01.placeholder03': `请输入优惠券名称`,
  'coupon.mgt.pricequantity.n01.lbl04': `优惠券副标题`,
  'coupon.mgt.pricequantity.n01.placeholder05': `请输入优惠券副标题`,
  'coupon.mgt.pricequantity.n01.lbl06': `优惠券备注`,
  'coupon.mgt.pricequantity.n01.placeholder07': `请输入优惠券备注`,
  'coupon.mgt.pricequantity.n01.lbl08': `发放总量`,
  'coupon.mgt.pricequantity.n01.placeholder09': `请输入发放总量`,
  'coupon.mgt.pricequantity.n01.rdo10': `使用门槛`,
  'coupon.mgt.pricequantity.n01.lbl11': `无使用门槛`,
  'coupon.mgt.pricequantity.n01.lbl12': `满足件数`,
  'coupon.mgt.pricequantity.n01.lbl13': `请输入满足件数`,
  'coupon.mgt.pricequantity.n01.lbl14': `折扣比例`,
  'coupon.mgt.pricequantity.n01.lbl15': `（原价为1,0.88即为八八折）`,
  'coupon.mgt.pricequantity.n01.txt16': `优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎`,
  'coupon.mgt.pricequantity.n01.lbl17': `用券时间`,
  'coupon.mgt.pricequantity.n01.rdo18': `开始日期`,
  'coupon.mgt.pricequantity.n01.rdo19': `结束日期`,
  'coupon.mgt.pricequantity.n01.chb20': `领券`,
  'coupon.mgt.pricequantity.n01.lbl21': `天内可用`,
  'coupon.mgt.pricequantity.n01.lbl22': `领取和使用规则`,
  'coupon.mgt.pricequantity.n01.rdo23': `领取人限制`,
  'coupon.mgt.pricequantity.n01.lbl24': `不限制，所有人可领`,
  'coupon.mgt.pricequantity.n01.lbl25': `指定用户身份可领（仅会员）`,
  'coupon.mgt.pricequantity.n01.rdo26': `每人限领次数`,
  'coupon.mgt.pricequantity.n01.lbl27': `不限次数`,
  'coupon.mgt.pricequantity.n01.lbl28': `限`,
  'coupon.mgt.pricequantity.n01.lbl29': `次`,
  'coupon.mgt.pricequantity.n01.chb30': `分享设置`,
  'coupon.mgt.pricequantity.n01.lbl31': `优惠券允许分享给好友领取`,
  'coupon.mgt.pricequantity.n01.chb32': `转赠设置`,
  'coupon.mgt.pricequantity.n01.lbl33': `优惠券允许转增给好友`,
  'coupon.mgt.pricequantity.n01.chb34': `使用条件`,
  'coupon.mgt.pricequantity.n01.lbl35': `不可与其他优惠券叠加使用`,
  'coupon.mgt.pricequantity.n01.lbl36': `不可会员优惠同享`,
  'coupon.mgt.pricequantity.n01.lbl37': `不可店铺促销同享`,
  'coupon.mgt.pricequantity.n01.lbl38': `不可非正价商品同享`,
  'coupon.mgt.pricequantity.n01.lbl39': `员工券`,
  'coupon.mgt.pricequantity.n01.lbl40': `使用此券消费金额可累计消费积分`,
  'coupon.mgt.pricequantity.n01.lbl41': `使用此券消费金额可算升级`,
  'coupon.mgt.pricequantity.n01.lbl42': `限制订单内商品件数`,
  'coupon.mgt.pricequantity.n01.lbl43': `件`,
  'coupon.mgt.pricequantity.n01.lbl44': `使用说明`,
  'coupon.mgt.pricequantity.n02.lbl01': `渠道设置`,
  'coupon.mgt.pricequantity.n02.chb02': `适用渠道`,
  'coupon.mgt.pricequantity.n02.lbl03': `官网`,
  'coupon.mgt.pricequantity.n02.lbl04': `爱步官网小程序`,
  'coupon.mgt.pricequantity.n02.lbl05': `线下渠道`,
  'coupon.mgt.pricequantity.n02.rdo06': `适用公司`,
  'coupon.mgt.pricequantity.n02.lbl07': `全部公司`,
  'coupon.mgt.pricequantity.n02.rdo08': `指定公司`,
  'coupon.mgt.pricequantity.n02.rdo09': `适用门店`,
  'coupon.mgt.pricequantity.n02.lbl10': `全部门店`,
  'coupon.mgt.pricequantity.n02.lbl11': `指定门店`,
  'coupon.mgt.pricequantity.n03.lbl01': `商品设置`,
  'coupon.mgt.pricequantity.n03.rdo02': `适用商品`,
  'coupon.mgt.pricequantity.n03.lbl03': `全部商品`,
  'coupon.mgt.pricequantity.n03.lbl04': `适用商品`,
  'coupon.mgt.pricequantity.n04.lbl01': `同步设置`,
  'coupon.mgt.pricequantity.n04.lbl02': `微信卡券同步设置`,
  'coupon.mgt.pricequantity.n04.lbl03': `微信卡券`,
  'coupon.mgt.pricequantity.n04.chb04': `领取后可同步至微信卡包`,
  'coupon.mgt.pricequantity.n04.rdo05': `选择模板`,
  'coupon.mgt.pricequantity.n04.lbl06': `适用商品范围`,
  'coupon.mgt.pricequantity.n04.placeholder07': `如：双十一优惠券，最多20字`,
  'coupon.mgt.pricequantity.n05.lbl01': `请输入满足件数`,
  'coupon.mgt.pricequantity.n05.lbl02': `满足件数是必填项`,
  'coupon.mgt.pricequantity.n05.lbl03': `请输入折扣比例`,
  'coupon.mgt.pricequantity.n05.lbl04': `折扣比例是必填项`,
  'coupon.mgt.pricequantity.n05.lbl05': `折扣比例不得大于1`,
  'coupon.mgt.n03.lbl01': `请输入优惠券名称`,
  'coupon.mgt.n03.lbl02': `优惠券名称是必填项`,
  'coupon.mgt.n03.lbl03': `请输入优惠券副标题`,
  'coupon.mgt.n03.lbl04': `优惠券副标题是必填项`,
  'coupon.mgt.n03.lbl05': `请输入优惠券备注`,
  'coupon.mgt.n03.lbl06': `请输入发放总量`,
  'coupon.mgt.n03.lbl07': `发放总量是必填项`,
  'coupon.mgt.n03.lbl08': `金额是必填项`,
  'coupon.mgt.n03.lbl09': `用券时间是必填项`,
  'coupon.mgt.n03.lbl10': `天数是必填项`,
  'coupon.mgt.n03.lbl11': `每人限领次数是必填项`,
  'coupon.mgt.n03.lbl12': `请填写优惠券的具体使用信息`,
  'coupon.mgt.n03.lbl13': `使用说明是必填项`,
  'coupon.mgt.n03.lbl14': `请输入门店名称`,
  'coupon.mgt.n03.lbl15': `适用渠道至少选择一项`,
  'coupon.mgt.n03.lbl16': `请选择公司`,
  'coupon.mgt.n03.lbl17': `请添加适用门店`,
  'coupon.mgt.n03.lbl18': `请输入款号名称`,
  'coupon.mgt.n03.lbl19': `请输入货号名称`,
  'coupon.mgt.n03.lbl20': `请输入商品名称`,
  'coupon.mgt.n03.lbl21': `请输入系列名称`,
  'coupon.mgt.n03.lbl22': `请输入全球季节名称`,
  'coupon.mgt.n03.lbl23': `请输入品类名称`,
  'coupon.mgt.n03.lbl24': `请输入大类名称`,
  'coupon.mgt.n03.lbl25': `请添加适用商品`,
};

export const coupon_enUS = {
  'coupon.mgt.volume.n01.lbl01': `BASIC OPTION`, //基本设置
  'coupon.mgt.volume.n01.lbl02': `COUPON NAME`, //优惠券名称
  'coupon.mgt.volume.n01.placeholder03': `PLEASE ENTER COUPON NAME`, //请输入优惠券名称
  'coupon.mgt.volume.n01.lbl04': `COUPON SUB-TITLE`, //优惠券副标题
  'coupon.mgt.volume.n01.placeholder05': `PLEASE ENTER COUPON SUB-TITLE`, //请输入优惠券副标题
  'coupon.mgt.volume.n01.lbl06': `COUPON REMARK`, //优惠券备注
  'coupon.mgt.volume.n01.placeholder07': `PLEASE ENTER COUPON REMARK`, //请输入优惠券备注
  'coupon.mgt.volume.n01.lbl08': `AMOUNT OF ISSUE`, //发放总量
  'coupon.mgt.volume.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`, //请输入发放总量
  'coupon.mgt.volume.n01.rdo10': `AVAILABLE CONDITION`, //使用门槛
  'coupon.mgt.volume.n01.lbl11': `ALL CONDITION`, //无使用门槛
  'coupon.mgt.volume.n01.lbl12': `NEEDING AN ORDER REACHES`, //订单满
  'coupon.mgt.volume.n01.lbl13': `YUAN TO USE`, //元可使用
  'coupon.mgt.volume.n01.lbl14': `COUPON DETAILS`, //优惠内容
  'coupon.mgt.volume.n01.lbl15': `DISCOUNT VALUES`, //减免
  'coupon.mgt.volume.n01.lbl16': `YUAN`, //元
  'coupon.mgt.volume.n01.txt17': `COUPON DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`, //优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎
  'coupon.mgt.volume.n01.lbl18': `VALID TIME`, //用券时间
  'coupon.mgt.volume.n01.rdo19': `FROM`, //开始日期
  'coupon.mgt.volume.n01.rdo20': `END`, //结束日期
  'coupon.mgt.volume.n01.chb21': `CAN BE USED IN`, //领券
  'coupon.mgt.volume.n01.lbl22': `DAYS`, //天内可用
  'coupon.mgt.volume.n01.lbl23': `RULES`, //领取和使用规则
  'coupon.mgt.volume.n01.rdo24': `WHO CAN RECEIVE`, //领取人限制
  'coupon.mgt.volume.n01.lbl25': `ALL PEOPLE`, //不限制，所有人可领
  'coupon.mgt.volume.n01.lbl26': `ONLY MEMBERS`, //指定用户身份可领（仅会员）
  'coupon.mgt.volume.n01.rdo27': `TIMES CAN MEMBERS RECEIVED`, //每人限领次数
  'coupon.mgt.volume.n01.lbl28': `NO LIMIT`, //不限次数
  'coupon.mgt.volume.n01.lbl29': `LIMITED FOR`, //限
  'coupon.mgt.volume.n01.lbl30': `TIMES`, //次
  'coupon.mgt.volume.n01.chb31': `SHARING OPTION`, //分享设置
  'coupon.mgt.volume.n01.lbl32': `ALLOWED TO SHARE TO FRIENDS`, //优惠券允许分享给好友领取
  'coupon.mgt.volume.n01.chb33': `GIVING OPTION`, //转赠设置
  'coupon.mgt.volume.n01.lbl34': `ALLOWED TO GIVE TO FRIENDS`, //优惠券允许转增给好友
  'coupon.mgt.volume.n01.chb35': `LIMIT CONDITIONS`, //使用条件
  'coupon.mgt.volume.n01.lbl36': `NOT ALLOWED WITH OTHER COUPON`, //不可与其他优惠券叠加使用
  'coupon.mgt.volume.n01.lbl37': `NOT ALLOWED WITH MEMBER DISCOUNT`, //不可会员优惠同享
  'coupon.mgt.volume.n01.lbl38': `NOT ALLOWED WITH STORE DISCOUNT`, //不可店铺促销同享
  'coupon.mgt.volume.n01.lbl39': `NOT ALLOWED WITH ITEM DISCOUNT`, //不可非正价商品同享
  'coupon.mgt.volume.n01.lbl40': `COUPON FOR STAFF`, //员工券
  'coupon.mgt.volume.n01.lbl41': `CALCULATED IN POINTS`, //使用此券消费金额可累计消费积分
  'coupon.mgt.volume.n01.lbl42': `CALCULATED IN LEVEL`, //使用此券消费金额可算升级
  'coupon.mgt.volume.n01.lbl43': `PIECES LIMITED IN AN ORDER`, //限制订单内商品件数
  'coupon.mgt.volume.n01.lbl44': `PIECES`, //件
  'coupon.mgt.volume.n01.lbl45': `EXPLANATION`, //使用说明
  'coupon.mgt.volume.n02.lbl01': `SOURCE OPTION`, //渠道设置
  'coupon.mgt.volume.n02.chb02': `SOURCE OF USING`, //适用渠道
  'coupon.mgt.volume.n02.lbl03': `OFFICIAL`, //官网
  'coupon.mgt.volume.n02.lbl04': `APPLETS`, //爱步官网小程序
  'coupon.mgt.volume.n02.lbl05': `OFFLINE`, //线下渠道
  'coupon.mgt.volume.n02.rdo06': `WHICH COMPANY TO USE`, //适用公司
  'coupon.mgt.volume.n02.lbl07': `ALL`, //全部公司
  'coupon.mgt.volume.n02.rdo08': `ONLY CAN USED IN`, //指定公司
  'coupon.mgt.volume.n02.rdo09': `WHICH STORE TO USE`, //适用门店
  'coupon.mgt.volume.n02.lbl10': `ALL`, //全部门店
  'coupon.mgt.volume.n02.lbl11': `ONLY CAN USED IN`, //指定门店
  'coupon.mgt.volume.n03.lbl01': `ITEM OPTION`, //商品设置
  'coupon.mgt.volume.n03.rdo02': `WHICH ITEM TO USE`, //适用商品
  'coupon.mgt.volume.n03.lbl03': `ONLY CAN USED IN`, //全部商品
  'coupon.mgt.volume.n03.lbl04': `ITEM OPTION`, //适用商品
  'coupon.mgt.volume.n04.lbl01': `SYNCHRONIZING OPTION`, //同步设置
  'coupon.mgt.volume.n04.lbl02': `WECHAT COUPON SYNCHRONIZING OPTION`, //微信卡券同步设置
  'coupon.mgt.volume.n04.lbl03': `WECHAT WALLET`, //微信卡券
  'coupon.mgt.volume.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`, //领取后可同步至微信卡包
  'coupon.mgt.volume.n04.rdo05': `CHOOSE TEMPLET`, //选择模板
  'coupon.mgt.volume.n04.lbl06': `ONLY CAN USED IN`, //适用商品范围
  'coupon.mgt.volume.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 COUPON.UP TO 20 WORDS.`, //如：双十一优惠券，最多20字
  'coupon.mgt.volume.n05.lbl01': `COUPON DISCOUNT MUST BE FILLED IN`, //优惠券减免是必填项
  'coupon.mgt.pricevalue.n01.lbl01': `BASIC OPTION`, //基本设置
  'coupon.mgt.pricevalue.n01.lbl02': `COUPON NAME`, //优惠券名称
  'coupon.mgt.pricevalue.n01.placeholder03': `PLEASE ENTER COUPON NAME`, //请输入优惠券名称
  'coupon.mgt.pricevalue.n01.lbl04': `COUPON SUB-TITLE`, //优惠券副标题
  'coupon.mgt.pricevalue.n01.placeholder05': `PLEASE ENTER COUPON SUB-TITLE`, //请输入优惠券副标题
  'coupon.mgt.pricevalue.n01.lbl06': `COUPON REMARK`, //优惠券备注
  'coupon.mgt.pricevalue.n01.placeholder07': `PLEASE ENTER COUPON REMARK`, //请输入优惠券备注
  'coupon.mgt.pricevalue.n01.lbl08': `AMOUNT OF ISSUE`, //发放总量
  'coupon.mgt.pricevalue.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`, //请输入发放总量
  'coupon.mgt.pricevalue.n01.rdo10': `AVAILABLE CONDITION`, //使用门槛
  'coupon.mgt.pricevalue.n01.lbl11': `ALL CONDITION`, //无使用门槛
  'coupon.mgt.pricevalue.n01.lbl12': `DISCOUNT PERCENTAGE`, //折扣比例
  'coupon.mgt.pricevalue.n01.lbl13': `1 MEANS NO DISCOUNT,0.88 MEANS 12% DISCOUNT`, //（原价为1,0.88即为八八折）
  'coupon.mgt.pricevalue.n01.txt14': `COUPON DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`, //优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎
  'coupon.mgt.pricevalue.n01.lbl15': `VALID TIME`, //用券时间
  'coupon.mgt.pricevalue.n01.rdo16': `FROM`, //开始日期
  'coupon.mgt.pricevalue.n01.rdo17': `END`, //结束日期
  'coupon.mgt.pricevalue.n01.chb18': `CAN BE USED IN`, //领券
  'coupon.mgt.pricevalue.n01.lbl19': `RULES`, //领取和使用规则
  'coupon.mgt.pricevalue.n01.rdo20': `WHO CAN RECEIVE`, //领取人限制
  'coupon.mgt.pricevalue.n01.lbl21': `ALL PEOPLE`, //不限制，所有人可领
  'coupon.mgt.pricevalue.n01.lbl22': `ONLY MEMBERS`, //指定用户身份可领（仅会员）
  'coupon.mgt.pricevalue.n01.rdo23': `TIMES CAN MEMBERS RECEIVED`, //每人限领次数
  'coupon.mgt.pricevalue.n01.lbl24': `NO LIMIT`, //不限次数
  'coupon.mgt.pricevalue.n01.lbl25': `LIMITED FOR`, //限
  'coupon.mgt.pricevalue.n01.lbl26': `TIMES`, //次
  'coupon.mgt.pricevalue.n01.chb27': `SHARING OPTION`, //分享设置
  'coupon.mgt.pricevalue.n01.lbl28': `ALLOWED TO SHARE TO FRIENDS`, //优惠券允许分享给好友领取
  'coupon.mgt.pricevalue.n01.chb29': `GIVING OPTION`, //转赠设置
  'coupon.mgt.pricevalue.n01.lbl30': `ALLOWED TO GIVE TO FRIENDS`, //优惠券允许转增给好友
  'coupon.mgt.pricevalue.n01.chb31': `LIMIT CONDITIONS`, //使用条件
  'coupon.mgt.pricevalue.n01.lbl32': `NOT ALLOWED WITH OTHER COUPON`, //不可与其他优惠券叠加使用
  'coupon.mgt.pricevalue.n01.lbl33': `NOT ALLOWED WITH MEMBER DISCOUNT`, //不可会员优惠同享
  'coupon.mgt.pricevalue.n01.lbl34': `NOT ALLOWED WITH STORE DISCOUNT`, //不可店铺促销同享
  'coupon.mgt.pricevalue.n01.lbl35': `NOT ALLOWED WITH ITEM DISCOUNT`, //不可非正价商品同享
  'coupon.mgt.pricevalue.n01.lbl36': `COUPON FOR STAFF`, //员工券
  'coupon.mgt.pricevalue.n01.lbl37': `CALCULATED IN POINTS`, //使用此券消费金额可累计消费积分
  'coupon.mgt.pricevalue.n01.lbl38': `CALCULATED IN LEVEL`, //使用此券消费金额可算升级
  'coupon.mgt.pricevalue.n01.lbl39': `PIECES LIMITED IN AN ORDER`, //限制订单内商品件数
  'coupon.mgt.pricevalue.n01.lbl40': `PIECES`, //件
  'coupon.mgt.pricevalue.n01.lbl41': `EXPLANATION`, //使用说明
  'coupon.mgt.pricevalue.n01.txt42': `COUPON NAME IS MANDATORY`, //优惠券名称是必填项
  'coupon.mgt.pricevalue.n01.txt43': `COUPON SUBHEADINGS ARE MANDATORY`, //优惠券副标题是必填项
  'coupon.mgt.pricevalue.n01.txt44': `PARAMETER IS MANDATORY`, //发放总量是必填项
  'coupon.mgt.pricevalue.n01.txt45': `AMOUNT IS MANDATORY`, //金额是必填项
  'coupon.mgt.pricevalue.n01.txt46': `AVAILABLE WITHIN`, //内可用
  'coupon.mgt.pricevalue.n01.txt47': `DISCOUNT OR EXEMPTION IS MANDATORY`, //优惠减免是必填项
  'coupon.mgt.pricevalue.n01.txt48': `PARAMETER IS MANDATORY`, //满足件数是必填项
  'coupon.mgt.pricevalue.n01.txt49': `PLEASE ENTER THE DISCOUNT RATE`, //请输入折扣比例
  'coupon.mgt.pricevalue.n01.txt50': `DISCOUNT RATE IS MANDATORY`, //折扣比例是必填项
  'coupon.mgt.pricevalue.n01.txt51': `THE DISCOUNT RATIO SHOULD NOT EXCEED 1`, //折扣比例不得大于1
  'coupon.mgt.pricevalue.n01.txt52': `FILL IN THE PRODUCT DESCRIPTION`, //填写商品描述
  'coupon.mgt.pricevalue.n01.txt53': `PRODUCT DESCRIPTION THIS PARAMETER IS MANDATORY`, //商品描述必填项
  'coupon.mgt.pricevalue.n01.txt54': `COUPON TIME IS MANDATORY`, //用券时间是必选项
  'coupon.mgt.pricevalue.n01.txt55': `ON THE DAY`, //当日
  'coupon.mgt.pricevalue.n01.txt56': `THE NEXT DAY`, //次日
  'coupon.mgt.pricevalue.n01.txt57': `SINCE`, //起
  'coupon.mgt.pricevalue.n01.txt58': `NUMBER OF DAYS IS MANDATORY`, //天数是必填项
  'coupon.mgt.pricevalue.n01.txt59': `LIMIT NUMBER OF TIMES PER PERSON IS MANDATORY`, //每人限领次数是必填项
  'coupon.mgt.pricevalue.n01.txt60': `IF THE NUMBER OF ITEMS IS NOT LIMITED, ENTER 0`, //如果不限制商品件数，输入0
  'coupon.mgt.pricevalue.n01.txt61': `FILL IN THE SPECIFIC USAGE INFORMATION OF THE COUPON`, //填写优惠券的具体使用信息
  'coupon.mgt.pricevalue.n01.txt62': `INSTRUCTIONS ARE MANDATORY`, //使用说明是必填项
  'coupon.mgt.pricevalue.n01.txt63': `STORE CODE`, //门店Code
  'coupon.mgt.pricevalue.n01.txt64': `STORE NAME`, //门店名称
  'coupon.mgt.pricevalue.n01.txt65': `ACTIVE`, //操作
  'coupon.mgt.pricevalue.n01.txt66': `SELECT STORES`, //选择门店
  'coupon.mgt.pricevalue.n01.txt67': `SELECT UNAVAILABLE STORES`, //选择不可用门店
  'coupon.mgt.pricevalue.n01.txt68': `PLEASE ENTER THE STORE NAME`, //请输入门店名称
  'coupon.mgt.pricevalue.n01.txt69': `SELECT AT LEAST ONE APPLICABLE CHANNEL`, //适用渠道至少选择一项
  'coupon.mgt.pricevalue.n01.txt70': `COMPANY NAME`, //公司名称
  'coupon.mgt.pricevalue.n01.txt71': `PLEASE SELECT COMPANY`, //请选择公司
  'coupon.mgt.pricevalue.n01.txt72': `PLEASE ADD APPLICABLE STORES`, //请添加适用门店
  'coupon.mgt.pricevalue.n01.txt73': `AVAILABLE STORES`, //可用门店
  'coupon.mgt.pricevalue.n01.txt74': `UNAVAILABLE STORE`, //不可用门店
  'coupon.mgt.pricevalue.n01.txt75': `ADD`, //添加
  'coupon.mgt.pricevalue.n01.txt76': `A TOTAL OF`, //共
  'coupon.mgt.pricevalue.n01.txt77': `CODING`, //编码
  'coupon.mgt.pricevalue.n01.txt78': `NAME`, //名称
  'coupon.mgt.pricevalue.n01.txt79': `CONTENT`, //内容
  'coupon.mgt.pricevalue.n01.txt80': `TYPE`, //类型
  'coupon.mgt.pricevalue.n01.txt81': `MODEL NO.`, //款号
  'coupon.mgt.pricevalue.n01.txt82': `ARTICLE NUMBER`, //货号
  'coupon.mgt.pricevalue.n01.txt83': `SERIES`, //系列
  'coupon.mgt.pricevalue.n01.txt84': `GLOBAL SEASON`, //全球季节
  'coupon.mgt.pricevalue.n01.txt85': `CATEGORY`, //品类
  'coupon.mgt.pricevalue.n01.txt86': `CATEGORIES`, //大类
  'coupon.mgt.pricevalue.n01.txt87': `PLEASE ENTER THE PAYMENT CODE NAME`, //请输入款号名称
  'coupon.mgt.pricevalue.n01.txt88': `PLEASE ENTER THE ARTICLE NUMBER`, //请输入货号名称
  'coupon.mgt.pricevalue.n01.txt89': `PLEASE ENTER THE NAME OF THE PRODUCT`, //请输入商品名称
  'coupon.mgt.pricevalue.n01.txt90': `PLEASE ENTER A SERIES NAME`, //请输入系列名称
  'coupon.mgt.pricevalue.n01.txt91': `PLEASE ENTER A GLOBAL SEASON NAME`, //请输入全球季节名称
  'coupon.mgt.pricevalue.n01.txt92': `PLEASE ENTER CATEGORY NAME`, //请输入品类名称
  'coupon.mgt.pricevalue.n01.txt93': `PLEASE ENTER A CATEGORY NAME`, //请输入大类名称
  'coupon.mgt.pricevalue.n01.txt94': `PLEASE ENTER THE PAYMENT CODE NAME`, //请输入款号名称
  'coupon.mgt.pricevalue.n01.txt95': `PLEASE ENTER A SERIES NAME`, //请输入系列名称
  'coupon.mgt.pricevalue.n01.txt96': `PLEASE ENTER THE NAME OF THE ACCESSORY TYPE`, //请输入配件种类名称
  'coupon.mgt.pricevalue.n01.txt97': `PLEASE ADD THE APPLICABLE PRODUCT`, //请添加适用商品
  'coupon.mgt.pricevalue.n01.txt98': `THE AVAILABLE GOODS`, //可用商品
  'coupon.mgt.pricevalue.n01.txt99': `THE`, //第
  'coupon.mgt.pricevalue.n01.txt100': `UNUSABLE GOODS`, //不可用商品
  'coupon.mgt.pricevalue.n01.txt101': `PLEASE SELECT TEMPLATE`, //请选择模板
  'coupon.mgt.pricevalue.n02.lbl01': `PLEASE ENTER DISCOUNT`, //请输入折扣比例
  'coupon.mgt.pricevalue.n02.lbl02': `DISCOUNT MUST BE FILLED IN`, //折扣比例是必填项
  'coupon.mgt.pricevalue.n02.lbl03': `DISCOUNT MUST SMALLER THAN 1`, //折扣比例不得大于1
  'coupon.mgt.exchange.n01.lbl08': `AMOUNT OF ISSUE`, //发放总量
  'coupon.mgt.exchange.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`, //请输入发放总量
  'coupon.mgt.exchange.n01.rdo10': `AVAILABLE CONDITION`, //使用门槛
  'coupon.mgt.exchange.n01.lbl11': `ALL CONDITION`, //无使用门槛
  'coupon.mgt.exchange.n01.lbl12': `ITEM DESCRIPTION`, //商品描述
  'coupon.mgt.exchange.n01.txt13': `COUPON DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`, //优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎
  'coupon.mgt.exchange.n01.lbl14': `VALID TIME`, //用券时间
  'coupon.mgt.exchange.n01.rdo15': `FROM`, //开始日期
  'coupon.mgt.exchange.n01.rdo16': `END`, //结束日期
  'coupon.mgt.exchange.n01.chb17': `CAN BE USED IN`, //领券
  'coupon.mgt.exchange.n01.lbl18': `DAYS`, //天内可用
  'coupon.mgt.exchange.n01.lbl19': `RULES`, //领取和使用规则
  'coupon.mgt.exchange.n01.rdo20': `WHO CAN RECEIVE`, //领取人限制
  'coupon.mgt.exchange.n01.lbl21': `ALL PEOPLE`, //不限制，所有人可领
  'coupon.mgt.exchange.n01.lbl22': `ONLY MEMBERS`, //指定用户身份可领（仅会员）
  'coupon.mgt.exchange.n01.rdo23': `TIMES CAN MEMBERS RECEIVED`, //每人限领次数
  'coupon.mgt.exchange.n01.lbl24': `NO LIMIT`, //不限次数
  'coupon.mgt.exchange.n01.lbl25': `LIMITED FOR`, //限
  'coupon.mgt.exchange.n01.lbl26': `TIMES`, //次
  'coupon.mgt.exchange.n01.chb27': `SHARING OPTION`, //分享设置
  'coupon.mgt.exchange.n01.lbl28': `ALLOWED TO SHARE TO FRIENDS`, //优惠券允许分享给好友领取
  'coupon.mgt.exchange.n01.chb29': `GIVING OPTION`, //转赠设置
  'coupon.mgt.exchange.n01.lbl30': `ALLOWED TO GIVE TO FRIENDS`, //优惠券允许转增给好友
  'coupon.mgt.exchange.n01.chb31': `LIMIT CONDITIONS`, //使用条件
  'coupon.mgt.exchange.n01.lbl32': `NOT ALLOWED WITH OTHER COUPON`, //不可与其他优惠券叠加使用
  'coupon.mgt.exchange.n01.lbl33': `NOT ALLOWED WITH MEMBER DISCOUNT`, //不可会员优惠同享
  'coupon.mgt.exchange.n01.lbl34': `NOT ALLOWED WITH STORE DISCOUNT`, //不可店铺促销同享
  'coupon.mgt.exchange.n01.lbl35': `NOT ALLOWED WITH ITEM DISCOUNT`, //不可非正价商品同享
  'coupon.mgt.exchange.n01.lbl36': `COUPON FOR STAFF`, //员工券
  'coupon.mgt.exchange.n01.lbl37': `CALCULATED IN POINTS`, //使用此券消费金额可累计消费积分
  'coupon.mgt.exchange.n01.lbl38': `CALCULATED IN LEVEL`, //使用此券消费金额可算升级
  'coupon.mgt.exchange.n01.lbl39': `PIECES LIMITED IN AN ORDER`, //限制订单内商品件数
  'coupon.mgt.exchange.n01.lbl40': `PIECES`, //件
  'coupon.mgt.exchange.n01.lbl41': `EXPLANATION`, //使用说明
  'coupon.mgt.exchange.n02.lbl01': `SOURCE OPTION`, //渠道设置
  'coupon.mgt.exchange.n02.chb02': `SOURCE OF USING`, //适用渠道
  'coupon.mgt.exchange.n02.lbl03': `OFFICIAL`, //官网
  'coupon.mgt.exchange.n02.lbl04': `APPLETS`, //爱步官网小程序
  'coupon.mgt.exchange.n02.lbl05': `OFFLINE`, //线下渠道
  'coupon.mgt.exchange.n02.rdo06': `WHICH COMPANY TO USE`, //适用公司
  'coupon.mgt.exchange.n02.lbl07': `ALL`, //全部公司
  'coupon.mgt.exchange.n02.rdo08': `ONLY CAN USED IN`, //指定公司
  'coupon.mgt.exchange.n02.rdo09': `WHICH STORE TO USE`, //适用门店
  'coupon.mgt.exchange.n02.lbl10': `ALL`, //全部门店
  'coupon.mgt.exchange.n02.lbl11': `ONLY CAN USED IN`, //指定门店
  'coupon.mgt.exchange.n03.lbl01': `ITEM OPTION`, //商品设置
  'coupon.mgt.exchange.n03.rdo02': `WHICH ITEM TO USE`, //适用商品
  'coupon.mgt.exchange.n03.lbl03': `ONLY CAN USED IN`, //全部商品
  'coupon.mgt.exchange.n03.lbl04': `ITEM OPTION`, //适用商品
  'coupon.mgt.exchange.n04.lbl01': `SYNCHRONIZING OPTION`, //同步设置
  'coupon.mgt.exchange.n04.lbl02': `WECHAT COUPON SYNCHRONIZING OPTION`, //微信卡券同步设置
  'coupon.mgt.exchange.n04.lbl03': `WECHAT WALLET`, //微信卡券
  'coupon.mgt.exchange.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`, //领取后可同步至微信卡包
  'coupon.mgt.exchange.n04.rdo05': `CHOOSE TEMPLET`, //选择模板
  'coupon.mgt.exchange.n04.lbl06': `ONLY CAN USED IN`, //适用商品范围
  'coupon.mgt.exchange.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 COUPON.UP TO 20 WORDS.`, //如：双十一优惠券，最多20字
  'coupon.mgt.exchange.n05.lbl01': `PLEASE FILL THE GIFT DESCRIPTION`, //请填写商品描述
  'coupon.mgt.exchange.n05.lbl02': `GIFT DESCRIPTION MUST BE FILLED IN`, //商品描述是必填项
  'coupon.mgt.pricequantity.n01.lbl01': `BASIC OPTION`, //基本设置
  'coupon.mgt.pricequantity.n01.lbl02': `COUPON NAME`, //优惠券名称
  'coupon.mgt.pricequantity.n01.placeholder03': `PLEASE ENTER COUPON NAME`, //请输入优惠券名称
  'coupon.mgt.pricequantity.n01.lbl04': `COUPON SUB-TITLE`, //优惠券副标题
  'coupon.mgt.pricequantity.n01.placeholder05': `PLEASE ENTER COUPON SUB-TITLE`, //请输入优惠券副标题
  'coupon.mgt.pricequantity.n01.lbl06': `COUPON REMARK`, //优惠券备注
  'coupon.mgt.pricequantity.n01.placeholder07': `PLEASE ENTER COUPON REMARK`, //请输入优惠券备注
  'coupon.mgt.pricequantity.n01.lbl08': `AMOUNT OF ISSUE`, //发放总量
  'coupon.mgt.pricequantity.n01.placeholder09': `PLEASE ENTER AMOUNT OF ISSUE`, //请输入发放总量
  'coupon.mgt.pricequantity.n01.rdo10': `AVAILABLE CONDITION`, //使用门槛
  'coupon.mgt.pricequantity.n01.lbl11': `ALL CONDITION`, //无使用门槛
  'coupon.mgt.pricequantity.n01.lbl12': `NEEDING AN ORDER REACHES VALUES OF`, //满足件数
  'coupon.mgt.pricequantity.n01.lbl13': `PLEASE ENTER AMOUNT OF ITEMS`, //请输入满足件数
  'coupon.mgt.pricequantity.n01.lbl14': `DISCOUNT PERCENTAGE`, //折扣比例
  'coupon.mgt.pricequantity.n01.lbl15': `1 MEANS 0% OFF,0.88 MEANS 12% OFF`, //（原价为1,0.88即为八八折）
  'coupon.mgt.pricequantity.n01.txt16': `COUPON DETAILS MEAN VALUE DEPOLYED.BE CAREFUL WHEN READY TO SET HUGE VALUE.`, //优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎
  'coupon.mgt.pricequantity.n01.lbl17': `VALID TIME`, //用券时间
  'coupon.mgt.pricequantity.n01.rdo18': `FROM`, //开始日期
  'coupon.mgt.pricequantity.n01.rdo19': `END`, //结束日期
  'coupon.mgt.pricequantity.n01.chb20': `CAN BE USED IN`, //领券
  'coupon.mgt.pricequantity.n01.lbl21': `DAYS`, //天内可用
  'coupon.mgt.pricequantity.n01.lbl22': `RULES`, //领取和使用规则
  'coupon.mgt.pricequantity.n01.rdo23': `WHO CAN RECEIVE`, //领取人限制
  'coupon.mgt.pricequantity.n01.lbl24': `ALL PEOPLE`, //不限制，所有人可领
  'coupon.mgt.pricequantity.n01.lbl25': `ONLY MEMBERS`, //指定用户身份可领（仅会员）
  'coupon.mgt.pricequantity.n01.rdo26': `TIMES CAN MEMBERS RECEIVED`, //每人限领次数
  'coupon.mgt.pricequantity.n01.lbl27': `NO LIMIT`, //不限次数
  'coupon.mgt.pricequantity.n01.lbl28': `LIMITED FOR`, //限
  'coupon.mgt.pricequantity.n01.lbl29': `TIMES`, //次
  'coupon.mgt.pricequantity.n01.chb30': `SHARING OPTION`, //分享设置
  'coupon.mgt.pricequantity.n01.lbl31': `ALLOWED TO SHARE TO FRIENDS`, //优惠券允许分享给好友领取
  'coupon.mgt.pricequantity.n01.chb32': `GIVING OPTION`, //转赠设置
  'coupon.mgt.pricequantity.n01.lbl33': `ALLOWED TO GIVE TO FRIENDS`, //优惠券允许转增给好友
  'coupon.mgt.pricequantity.n01.chb34': `LIMIT CONDITIONS`, //使用条件
  'coupon.mgt.pricequantity.n01.lbl35': `NOT ALLOWED WITH OTHER COUPON`, //不可与其他优惠券叠加使用
  'coupon.mgt.pricequantity.n01.lbl36': `NOT ALLOWED WITH MEMBER DISCOUNT`, //不可会员优惠同享
  'coupon.mgt.pricequantity.n01.lbl37': `NOT ALLOWED WITH STORE DISCOUNT`, //不可店铺促销同享
  'coupon.mgt.pricequantity.n01.lbl38': `NOT ALLOWED WITH ITEM DISCOUNT`, //不可非正价商品同享
  'coupon.mgt.pricequantity.n01.lbl39': `COUPON FOR STAFF`, //员工券
  'coupon.mgt.pricequantity.n01.lbl40': `CALCULATED IN POINTS`, //使用此券消费金额可累计消费积分
  'coupon.mgt.pricequantity.n01.lbl41': `CALCULATED IN LEVEL`, //使用此券消费金额可算升级
  'coupon.mgt.pricequantity.n01.lbl42': `PIECES LIMITED IN AN ORDER`, //限制订单内商品件数
  'coupon.mgt.pricequantity.n01.lbl43': `PIECES`, //件
  'coupon.mgt.pricequantity.n01.lbl44': `EXPLANATION`, //使用说明
  'coupon.mgt.pricequantity.n02.lbl01': `SOURCE OPTION`, //渠道设置
  'coupon.mgt.pricequantity.n02.chb02': `SOURCE OF USING`, //适用渠道
  'coupon.mgt.pricequantity.n02.lbl03': `OFFICIAL`, //官网
  'coupon.mgt.pricequantity.n02.lbl04': `APPLETS`, //爱步官网小程序
  'coupon.mgt.pricequantity.n02.lbl05': `OFFLINE`, //线下渠道
  'coupon.mgt.pricequantity.n02.rdo06': `WHICH COMPANY TO USE`, //适用公司
  'coupon.mgt.pricequantity.n02.lbl07': `ALL`, //全部公司
  'coupon.mgt.pricequantity.n02.rdo08': `ONLY CAN USED IN`, //指定公司
  'coupon.mgt.pricequantity.n02.rdo09': `WHICH STORE TO USE`, //适用门店
  'coupon.mgt.pricequantity.n02.lbl10': `ALL`, //全部门店
  'coupon.mgt.pricequantity.n02.lbl11': `ONLY CAN USED IN`, //指定门店
  'coupon.mgt.pricequantity.n03.lbl01': `ITEM OPTION`, //商品设置
  'coupon.mgt.pricequantity.n03.rdo02': `WHICH ITEM TO USE`, //适用商品
  'coupon.mgt.pricequantity.n03.lbl03': `ONLY CAN USED IN`, //全部商品
  'coupon.mgt.pricequantity.n03.lbl04': `ITEM OPTION`, //适用商品
  'coupon.mgt.pricequantity.n04.lbl01': `SYNCHRONIZING OPTION`, //同步设置
  'coupon.mgt.pricequantity.n04.lbl02': `WECHAT COUPON SYNCHRONIZING OPTION`, //微信卡券同步设置
  'coupon.mgt.pricequantity.n04.lbl03': `WECHAT WALLET`, //微信卡券
  'coupon.mgt.pricequantity.n04.chb04': `SYNCHRONIZE TO WECHAT WALLET AFTER RECEIVED`, //领取后可同步至微信卡包
  'coupon.mgt.pricequantity.n04.rdo05': `CHOOSE TEMPLET`, //选择模板
  'coupon.mgt.pricequantity.n04.lbl06': `ONLY CAN USED IN`, //适用商品范围
  'coupon.mgt.pricequantity.n04.placeholder07': `FOR EXAMPLE:DOUBLE 11 COUPON.UP TO 20 WORDS.`, //如：双十一优惠券，最多20字
  'coupon.mgt.pricequantity.n05.lbl01': `PLEASE ENTER PAIRS TO USE COUPON`, //请输入满足件数
  'coupon.mgt.pricequantity.n05.lbl02': `PAIRS TO USE COUPON MUST BE FILLED IN`, //满足件数是必填项
  'coupon.mgt.pricequantity.n05.lbl03': `PLEASE ENTER DISCOUNT`, //请输入折扣比例
  'coupon.mgt.pricequantity.n05.lbl04': `DISCOUNT MUST BE FILLED IN`, //折扣比例是必填项
  'coupon.mgt.pricequantity.n05.lbl05': `DISCOUNT MUST SMALLER THAN 1`, //折扣比例不得大于1
  'coupon.mgt.n03.lbl01': `PLEASE ENTER COUPON NAME`, //请输入优惠券名称
  'coupon.mgt.n03.lbl02': `COUPON NAME MUST BE FILLED IN`, //优惠券名称是必填项
  'coupon.mgt.n03.lbl03': `PLEASE ENTER COUPON SUB-NAME`, //请输入优惠券副标题
  'coupon.mgt.n03.lbl04': `COUPON SUB-NAME MUST BE FILLED IN`, //优惠券副标题是必填项
  'coupon.mgt.n03.lbl05': `PLEASE ENTER COUPON REMARK`, //请输入优惠券备注
  'coupon.mgt.n03.lbl06': `PLEASE ENTER COUPON AMOUNTS`, //请输入发放总量
  'coupon.mgt.n03.lbl07': `COUPON AMOUNT MUST BE FILLED IN`, //发放总量是必填项
  'coupon.mgt.n03.lbl08': `VALUE MUST BE FILLED IN`, //金额是必填项
  'coupon.mgt.n03.lbl09': `COUPON TIME MUST BE FILLED IN`, //用券时间是必填项
  'coupon.mgt.n03.lbl10': `DAYS MUST BE FILLED IN`, //天数是必填项
  'coupon.mgt.n03.lbl11': `RECEIVE LIMIT PER MEMBER MUST BE FILLED IN`, //每人限领次数是必填项
  'coupon.mgt.n03.lbl12': `PLEASE ENTER COUPON INSTRUCTION`, //请填写优惠券的具体使用信息
  'coupon.mgt.n03.lbl13': `COUPON INSTRUCTION MUST BE FILLED IN`, //使用说明是必填项
  'coupon.mgt.n03.lbl14': `PLEASE ENTER STORE NAME`, //请输入门店名称
  'coupon.mgt.n03.lbl15': `SOURCE MUST BE CHOOSED`, //适用渠道至少选择一项
  'coupon.mgt.n03.lbl16': `PLEASE CHOOSE COMPANY`, //请选择公司
  'coupon.mgt.n03.lbl17': `PLEASE ADD APPLICABLE STORE`, //请添加适用门店
  'coupon.mgt.n03.lbl18': `PLEASE ENTER STYLE NUMBER`, //请输入款号名称
  'coupon.mgt.n03.lbl19': `PLEASE ENTER SKU`, //请输入货号名称
  'coupon.mgt.n03.lbl20': `PLEASE ENTER ITEM NAME`, //请输入商品名称
  'coupon.mgt.n03.lbl21': `PLEASE ENTER SERIES NAME`, //请输入系列名称
  'coupon.mgt.n03.lbl22': `PLEASE ENTER GLOBAL SEASON`, //请输入全球季节名称
  'coupon.mgt.n03.lbl23': `PLEASE ENTER CATEGORY`, //请输入品类名称
  'coupon.mgt.n03.lbl24': `PLEASE ENTER MAIN CATEGORY`, //请输入大类名称
  'coupon.mgt.n03.lbl25': `PLEASE ENTER APPLICABLE ITEMS`, //请添加适用商品
};
